import axios from 'axios';
import {API_ADMIN} from '@/utils/constants/Api'
import { CategoryModel } from '@/category/models/CategoryModel';
import { IFilterList } from '@/utils/interfaces/FilterListInterface';
import { BaseAssociableEntity, BaseChannelBackendAssociation } from '@c2b/muven-commons';
import { IEntityAssociation } from '../../utils/interfaces/EntityAssociationInterface';
import { CategoryNodeModel } from '../models/CategoryNodeModel';
import { CategoryFormModel } from '../models/CategoryFormModel';

class CategoryService implements IEntityAssociation {
    getCategories(page:number, filter:IFilterList):Promise<CategoryModel[]> {
        return axios.get(`${API_ADMIN}categories?page=${page}${filter.toPartialQueryString()}`)
            .then(({data}) => {
                return data.map((c:CategoryModel) => {
                    return new CategoryModel(c)
                })
            })
    }

    getCategoryTree():Promise<CategoryNodeModel[]> {
        return axios.get(`${API_ADMIN}categories/tree`)
            .then(({data}) => {
                return data.map((c:CategoryNodeModel) => {
                    return new CategoryNodeModel(c)
                })
            })
    }

    getAllCategories():Promise<CategoryModel[]> {
        return axios.get(`${API_ADMIN}categories/all`)
            .then(({data}) => {
                return data.map((c:CategoryModel) => {
                    return new CategoryModel(c)
                })
            })
    }

    createOrUpdateCategory(cat: CategoryFormModel):Promise<CategoryModel> {
        if (!cat.hasId()) {
            return this.createCategory(cat)
        }

        return this.updateCategory(cat)
    }

    createCategory(cat: CategoryFormModel):Promise<CategoryModel> {
        return axios.post(`${API_ADMIN}categories`, cat)
            .then(({data}) => {
                return new CategoryModel(data);
            });
    }

    updateCategory(cat: CategoryFormModel):Promise<CategoryModel> {
        return axios.put(`${API_ADMIN}categories/${cat.id}`, cat)
            .then(({data}) => {
                return new CategoryModel(data);
            });
    }

    getEntitiesInBackend(channelId:number):Promise<BaseAssociableEntity[]> {
        return axios.get(`${API_ADMIN}categories/in_muven/from_channel/${channelId}`)
            .then(({data}) => {
                return data.map((b:BaseAssociableEntity) => new BaseAssociableEntity(b))
            })
    }

    getEntitiesInChannel(channelId:number, term?:string):Promise<BaseAssociableEntity[]> {
        // `term` só é usado por canais com associação por busca ao vivo (ex.: Mercado Livre),
        // que não possuem listagem completa de categorias. Sem termo, o admin-api devolve a
        // lista cacheada completa (comportamento inalterado para os demais canais).
        const query = term ? `?info=${encodeURIComponent(term)}` : ''
        return axios.get(`${API_ADMIN}categories/in_channel/${channelId}${query}`)
            .then(({data}) => {
                return data.map((b:BaseAssociableEntity) => new BaseAssociableEntity(b))
            })
    }

    getCategoryById(id:number):Promise<CategoryModel> {
        return axios.get(`${API_ADMIN}categories/${id}`)
            .then(({data}) => {
                return new CategoryModel(data)
            })
    }

    updateAllowExportInCategory(idCategory: number, allowExport:boolean):Promise<any> {
        return axios.patch(`${API_ADMIN}categories/${idCategory}/allow_export/${allowExport}`)
            .then(({data}) => {
                return data
            })
    }

    updateAllowExportInCategoryChannel(idCategoryChannel: number, allowExport:boolean):Promise<any> {
        return axios.patch(`${API_ADMIN}categories/channel/allow_export/${idCategoryChannel}/${allowExport}`)
            .then(({data}) => {
                return data
            })
    }   

    associateChannelEntitiesWithBackendEntities(associationList:BaseChannelBackendAssociation[], channelId:number):Promise<any> {
        return axios.post(`${API_ADMIN}categories/association/in_channel/${channelId}`, associationList)
            .then(({data}) => {
                return data
            })    
    }

    deleteCategory(id:number):Promise<any> {
        return axios.delete(`${API_ADMIN}categories/${id}`)
    }

    forceChannelsSync(id:number):Promise<void> {
        return axios.post(`${API_ADMIN}categories/${id}/force_channels_sync`)
    }
}

export default new CategoryService()
